export default __webpack_public_path__ + "static/media/Photo 8 - BR - plan bien orienté.073cc1cf.png";